module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page bg-primary"
  }, [(!_vm.success) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Geef je emailadres in")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Uw Emailadres"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "uk-alert-danger"
  }, [_vm._v(_vm._s(_vm.error.code))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ForgotPassword($event)
      }
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("VERZENDEN")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Aanmelden")])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "uk-card uk-card-body uk-card-default uk-position-center"
  }, [_c('h1', {
    staticClass: "uk-card-title"
  }, [_vm._v("Email verzonden!")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7b02498","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/pages/ForgotPassword.vue
// module id = 526
// module chunks = 1